export default function AllMenuIcon({
    style
}) {

    return <svg width="25" height="25" viewBox="0 0 25 25" fill="none" style={style}>
    <mask id="mask0_535_162" maskUnits="userSpaceOnUse" x="0" y="0" width="25" height="25">
    <rect x="0.857422" y="0.0888672" width="24" height="24" fill="#D9D9D9"/>
    </mask>
    <g mask="url(#mask0_535_162)">
    <path d="M17.5074 13.0891L11.8574 7.43906L17.5074 1.78906L23.1574 7.43906L17.5074 13.0891ZM3.85742 11.0891V3.08906H11.8574V11.0891H3.85742ZM13.8574 21.0891V13.0891H21.8574V21.0891H13.8574ZM3.85742 21.0891V13.0891H11.8574V21.0891H3.85742ZM5.85742 9.08906H9.85742V5.08906H5.85742V9.08906ZM15.8574 19.0891H19.8574V15.0891H15.8574V19.0891ZM5.85742 19.0891H9.85742V15.0891H5.85742V19.0891Z" fill="black"/>
    </g>
    </svg>
    
}